import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "action-footer" }
const _hoisted_2 = { class: "action-footer__header" }
const _hoisted_3 = { class: "action-footer__title" }
const _hoisted_4 = {
  key: 0,
  class: "action-footer__subtitle"
}
const _hoisted_5 = { class: "action-footer__actions" }
const _hoisted_6 = { class: "action-footer__primary-button__text" }
const _hoisted_7 = { class: "action-footer__primary-button__data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ozn_button = _resolveComponent("ozn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title || 'Default title'), 1)
      ], true),
      _renderSlot(_ctx.$slots, "subtitle", {}, () => [
        (_ctx.subtitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.subtitleCount) + " " + _toDisplayString(_ctx.subtitle || 'default subtitle'), 1))
          : _createCommentVNode("", true)
      ], true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "primary", {}, () => [
        _createVNode(_component_ozn_button, {
          class: "action-footer__primary-button",
          onClick: _ctx.primaryButtonAction
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.primaryButtonText), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.primaryButtonCount) + _toDisplayString(_ctx.primaryButtonUnit || ''), 1)
      ], true),
      _renderSlot(_ctx.$slots, "secondary", {}, () => [
        _createVNode(_component_ozn_button, {
          class: "action-footer__secondary-button",
          onClick: _ctx.secondaryButtonAction
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t-icon" }, "j", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.secondaryButtonText), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ], true),
      _renderSlot(_ctx.$slots, "custom", {}, undefined, true)
    ])
  ]))
}